
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.814 4.266a6.35 6.35 0 0 0-2.47 2.471M5.975 1.5A6.5 6.5 0 0 0 1.5 5.976M4.5 18h15m0 0S18 16.694 18 12c0-3.75-2.562-7.068-6-7.068S6 8.25 6 12c0 4.719-1.5 6-1.5 6m9 3a1.5 1.5 0 0 1-3 0M12 4.932V3m5.186 1.266a6.456 6.456 0 0 1 1.408 1.062 6.391 6.391 0 0 1 1.062 1.409M18.025 1.5A6.5 6.5 0 0 1 22.5 5.976","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    